import {useEffect, useRef} from 'react';
import {useMutation} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import {getVehicleslist} from '../actions/vehicleslist';
import {useApi} from '../providers/ApiProvider';
import {getMap} from '../actions/map';
import {getApp} from '../actions/app';
import {checkPermitionAndGetPosition} from './location';
let lat = undefined;
let lng = undefined;

function useVehiclesList() {
  const dispatch = useDispatch();
  const {api} = useApi();
  const {intervallFuncRef} = useSelector(state => state?.app);

  const vehiclesMutation = useMutation({
    mutationFn: async params => {
      return api.vehicles(params);
    },
    onSuccess: resVehicles => {

      let data = resVehicles?.Data?.vehicleTypes ?? [];

      let arrayofbicycle = data.filter(obj => {
        return obj.name === 'Bicycle';
      });
      let bicycles = (arrayofbicycle[0]?.vehicle ?? [])
        .filter(obj => obj.IsStationOpen === true)
        .map(function (el) {
          var o = Object.assign({}, el);
          o.type = 'Bicycle';
          o.price = arrayofbicycle[0]?.price;
          o.pause_coefficient = arrayofbicycle[0]?.pause_coefficient;
          o.code_prefix = arrayofbicycle[0]?.code_prefix;
          return o;
        });
      let arrayofbike = data.filter(obj => {
        return obj.name === 'Bike';
      });
      let bikes = (arrayofbike[0]?.vehicle ?? [])
        .filter(obj => obj.IsStationOpen === true)
        .map(function (el) {
          var o = Object.assign({}, el);

          o.type = 'Bike';
          o.price = arrayofbike[0]?.price;
          o.pause_coefficient = arrayofbike[0]?.pause_coefficient;
          o.code_prefix = arrayofbike[0]?.code_prefix;

          return o;
        });
      let both = bikes?.concat(bicycles);
      const discounts = both.filter(item => item.discount_percent > 0);
      dispatch(
        getVehicleslist({
          Bikes: bikes,
          Bicycles: bicycles,
          Scooter: bicycles,
          Discounts: discounts,
          Both: both,
          vehicleIsLoading: false,
        }),
      );
    },
  });

  const stationsMutation = useMutation({
    mutationFn: async () => {
      return api.stations();
    },
    onSuccess: resStations => {
      let stations = resStations?.Data?.station_types?.[1]?.stations;
      dispatch(
        getVehicleslist({
          parking: stations,
          stationIsLoading: false,
        }),
      );
    },
  });

  async function fn(hasLocation, isFirst) {
    if (hasLocation) {
      checkPermitionAndGetPosition({
        onSuccess: position => {
          lat = position.coords?.latitude;
          lng = position.coords?.longitude;
          if (isFirst) {
            vehiclesMutation.mutate({
              ulat: lat,
              ulng: lng,
            });
          }
        },
      });
      if (!isFirst) {
        vehiclesMutation.mutate({
          ulat: lat,
          ulng: lng,
        });
      }
      stationsMutation.mutate();
    } else {
      vehiclesMutation.mutate();
      stationsMutation.mutate();
    }
  }
  const interval = useRef();

  const startReloadVehicleList = props => {
    const hasLocation = props?.hasLocation ?? false;
    if (!intervallFuncRef) {
      fn(hasLocation, true);
      setTimeout(() => {
        dispatch(
          getMap({
            refreshNearestView: true,
          }),
        );
      }, 1000);
      interval.current = setInterval(() => fn(hasLocation, false), 30000);
      dispatch(
        getApp({
          intervallFuncRef: interval.current,
        }),
      );
    }
  };

  const stopReloadVehicleList = () => {
    dispatch(
      getApp({
        intervallFuncRef: undefined,
      }),
    );
    clearInterval(intervallFuncRef);
  };

  const reloadVehicleList = () => vehiclesMutation.mutate();

  return {
    reloadVehicleList,
    startReloadVehicleList,
    stopReloadVehicleList,
  };
}
export default useVehiclesList;
